'use client';

import dynamic from 'next/dynamic';
import type { ComponentProps } from 'react';

type ConfiguratorProps = ComponentProps<typeof import('./page').default>;

// Keep the tenant's 3D/calculation bundle behind a client-to-client boundary.
// SSR remains enabled on the configurator route; the shared server route
// registry only imports this small boundary on unrelated pages.
const ConfiguratorClient = dynamic<ConfiguratorProps>(() => import('./page'));

export default ConfiguratorClient;
